var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.$brand.logo,"alt":"loading...","width":"200"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }